import { IonicColor } from "aar-ionic-component-library/dist/ngx-aar-ionic-library";
import { round } from "lodash";
import { workCardStepsModel, workCardStepsResModel, WorkCardStepsStatus } from "../models/workCardSteps";
import { formatNumber } from "@angular/common";
import { RoutineCustomerStepsResModel, WorkcardSteps } from "../models/request-payload";
import { CIRStep } from "../service-modules/data-accessors/work-card-accessor.service";

export class DataHelper {
  calculateDays(inductionDate: Date): number {
    let today = new Date();
    let localizedInductionDate = this.adjustForTimezone(new Date(inductionDate));

    let diffdifferenceInMilliseconds = Math.abs(today.getTime() - localizedInductionDate.getTime());
    let differenceInDays = Math.ceil(diffdifferenceInMilliseconds / (1000 * 3600 * 24));
    return differenceInDays;
  }

  calculateTargetCycleDays(inductionDate: Date, targetDate: Date): number {
    let localizedTargetDate = this.adjustForTimezone(new Date(targetDate));
    let localizedInductionDate = this.adjustForTimezone(new Date(inductionDate));

    let differenceInMilliseconds = Math.abs(localizedTargetDate.getTime() - localizedInductionDate.getTime());
    let differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
    return differenceInDays;
  }

  adjustForTimezone(date: Date): Date {
    let timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() + timeOffsetInMS);
    return date;
  }

  calculateper(val1, val2) {
    const value1 = val1 ?? 0;
    const value2 = val2 ?? 0;
    let iconColor = "";
    let ionicColor = IonicColor.dark;
    let iconName = "";
    let actualPer: any = round((value1 / value2) * 100.0);
    let indicatorVal: any = (value1 / value2);
    if (actualPer >= 0 && actualPer < 80) {
      ionicColor = IonicColor.dark;
      indicatorVal = (value1 / value2);
    }
    if (actualPer >= 80 && actualPer < 100) {
      ionicColor = IonicColor.warning;
      indicatorVal = (value1 / value2);
      iconColor = "warning";
      iconName = "time";
    }
    if (actualPer >= 100) {
      ionicColor = IonicColor.danger;
      indicatorVal = (value1 / value2);
      iconColor = "danger";
      iconName = "alert-circle";
    }

    return {
      "ionicColor": ionicColor, "per": parseFloat(actualPer).toFixed(0), "indicatorVal": indicatorVal.toFixed(2),
      "iconColor": iconColor, "iconName": iconName
    };
  }

  DayOfCheck(val1, val2) {
    let value1 = val1;
    let value2 = val2;
    let ionicColor = IonicColor.dark;

    let actualPer: any = (value1 / value2) * 100;
    let indicatorVal: any = (value1 / value2);
    if (actualPer >= 100) {
      ionicColor = IonicColor.danger;
      indicatorVal = (value1 / value2);
    } else {
      ionicColor = IonicColor.dark;
      indicatorVal = (value1 / value2);
    }
    return {
      "ionicColor": ionicColor, "per": parseFloat(actualPer).toFixed(1), "indicatorVal": indicatorVal.toFixed(2),
    };
  }

  numberWithCommas(number: any) {
    if (number !== null && number !== undefined) {
      let parts = number.toString().split(".");
      parts[0] = formatNumber(Number(parts[0]), 'en-US', '1.0-0');
      return parts.join(".");
    } else {
      return 'N/A';
    }
  }

  ellipseText(input: string, limit: number = 33) {
    if (input?.length > limit) {
      return input.substring(0, limit) + '...';
    }
    return input;
  }

  constructQueryString(params: any) {
    let newObj = {};
    Object.keys(params).forEach(function (key) {
      if (params[key] !== null && params[key] !== '')
        newObj[key] = params[key];
    });
    let queryString = Object.keys(newObj).map(key => key + '=' + newObj[key]).join('&');
    return queryString;
  }

  timeOnCard(per: number) {
    let ionicColor = IonicColor.dark;
    let indicatorVal: any = (per / 100);
    if (per >= 0 && per < 80) {
      ionicColor = IonicColor.dark;
    }
    if (per >= 80 && per < 100) {
      ionicColor = IonicColor.warning;
    }
    if (per >= 100) {
      ionicColor = IonicColor.danger;
    }
    return { "ionicColor": ionicColor, "indicatorVal": indicatorVal };
  }

  // Return technician and inspector status of work card steps.
  workCardStepsData(params: workCardStepsModel, isEditable?: boolean): WorkCardStepsStatus {
    if (this.checkRequestInspectionWithoutMechFlag(params)) {
      return this.updateWorkCardStepData(true, 'Add stamp', 'Request Inspection', true);
    }

    if (this.checkRequestInspectionWithoutMechFlagReject(params)) {
      return this.updateWorkCardStepData(true, 'Add stamp', 'Request Re-Inspection', true);
    }
    if (this.checkRequestInspectionWithMechFlag(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Request Inspection', true);
    }

    if (this.checkRequestInspectionWithMechFlagReject(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Request Re-Inspection', true);
    }
    if (this.checkRequestInspectionWithoutMechFlagOpenNew(params)) {
      return this.updateWorkCardStepData(true, 'Add stamp', 'Request Inspection', true);
    }
    if (this.checkRequestInspectionWithMechFlagOpenNew(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Request Inspection', true);
    }
    if (this.checkRequestInspectionWithMechFlagInspFlag(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Request Re-Inspection', true);
    }
    if (this.checkRequestInspectionWithoutMechFlagInspFlag(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Request Re-Inspection', true);
    }

    // Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
    // Case 1: Handling the initial inspection rejection by inspector
    if (this.isInitialInspectionRejected(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Inspection Rejected', false);
    }

    // Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
    // Case 2: Handling a correction after the inspection was initially rejected
    if (this.isCorrectionAfterInspectionReject(params)) {
      return this.updateWorkCardStepData(true, 'Add stamp', 'Request Re-Inspection', true);
    }

    // Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
    // Case 3: Processing the scenario where an inspection is requested after a CIR rejection
    if (this.isInspectionRequestedAfterReject(params)) {
      return this.updateWorkCardStepData(false, params.STAMPED_BY_MECHANIC_DATE, 'Awaiting Inspection', isEditable);
    }

    // When inspector start inspection, and Inspector stamp not wiped out by DB in case of Inspection on Behalf of Customer
    if (this.isInspectionRequestedAfterReject(params)) {
      return this.updateWorkCardStepData(false, params.STAMPED_BY_MECHANIC_DATE, 'Inspection In Progress', false);
    }

    // Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
    // Case 4: Handling a canceled inspection by a technician after CIR rejection
    if (this.isInspectionCanceledByTechnician(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Request Re-Inspection', true);
    }

    // Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
    // Case 5: Handling the scenario where an inspection is in progress after CIR rejection
    if (this.isInspectionInProgressAfterReject(params)) {
      return this.updateWorkCardStepData(false, '', 'Inspection In Progress', false);
    }

    if (this.checkAwaitingInpection(params)) {
      return this.updateWorkCardStepData(false, params.STAMPED_BY_MECHANIC_DATE, 'Awaiting Inspection', isEditable);
    }
    if (this.checkRequestInspectionWithMechFlagInspRejectFlag(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Inspection Rejected', false);
    }
    // for final buyback correct scenario
    if (this.checkFinalBuybackCorrected(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Inspection Rejected', false);
    }
     //-- Start
     if (this.checkAwaitingInpectionWithoutMechFlag(params)) {
      return this.updateWorkCardStepData(false, 'Add stamp', 'Awaiting Inspection', isEditable);
    }
    //--End
    if (this.checkInspectionInprogress(params)) {
      return this.updateWorkCardStepData(false, '', 'Inspection In Progress', isEditable);
    }
     //---Start
     if (this.checkInspectionInprogressWithoutMechFlag(params)) {
       return this.updateWorkCardStepData(false, 'Add stamp', 'Inspection In Progress', isEditable);
     }
     //--End
    if (this.checkStatusWithoutInsAndMechFlag(params)) {
      return this.updateWorkCardStepData(true, 'Add stamp', 'Request Re-Inspection', isEditable);
    }

    if (this.checkRejectMaintStampNotExist(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, 'Inspection Rejected', false);
    }

    if (this.checkStatusWithInsAndMechFlag(params)) {
      return this.updateWorkCardStepData(false, params.STAMPED_BY_MECHANIC_DATE, params.STAMPED_BY_INSPECTOR_DATE, false);
    }
    //--Start
    if (this.checkStatusWithInsDoneWithoutMechFlag(params)) {
      return this.updateWorkCardStepData(false, params.STAMPED_BY_MECHANIC_DATE, params.STAMPED_BY_INSPECTOR_DATE, false);
    }
    //--End
    if (this.checkWithInspectorSignOffFlag(params)) {
      return this.updateWorkCardStepData(true, 'Add stamp', '', false);
    }
    if (this.checkWithoutInspectorSignOffFlag(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, '', false);
    }

    if (this.checkStatusWithInsDoneWithoutMechFlagOpenNew(params)) {
      return this.updateWorkCardStepData(true, 'Add stamp', '', false);
    }
    if (this.checkWithInspectorSignOffFlagOpenNew(params)) {
      return this.updateWorkCardStepData(true, params.STAMPED_BY_MECHANIC_DATE, '', false);
    }
  }

  //Set step status if Mechanic flag is N.
  private checkRequestInspectionWithoutMechFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'IN-WORK' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'N'
      && params.CURRENT_ACTIVITY_RESULT !== 'REJECT'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

  private checkRequestInspectionWithoutMechFlagReject(params: workCardStepsModel): boolean {
    if (params.STATUS === 'IN-WORK' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'N'
      && params.CURRENT_ACTIVITY_RESULT === 'REJECT'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

  //Set step status if Mechanic flag is Y.
  private checkRequestInspectionWithMechFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'IN-WORK' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
      && params.CURRENT_ACTIVITY_RESULT !== 'REJECT'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

  private checkRequestInspectionWithMechFlagReject(params: workCardStepsModel): boolean {
    if (params.STATUS === 'IN-WORK' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
      && params.CURRENT_ACTIVITY_RESULT === 'REJECT'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

    //Set step status if Mechanic flag is N.Open -New status
    private checkRequestInspectionWithoutMechFlagOpenNew(params: workCardStepsModel): boolean {
      if (params.STATUS === 'OPEN' && params.STATUS_REASON === 'NEW'
        && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
        && params.STAMPED_BY_MECHANIC_FLAG === 'N'
        && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
        return true;
      }
      else {
        return false;
      }
    }

    //Set step status if Mechanic flag is Y. For Open -New status
    private checkRequestInspectionWithMechFlagOpenNew(params: workCardStepsModel): boolean {
      if (params.STATUS === 'OPEN' && params.STATUS_REASON === 'NEW'
        && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
        && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
        && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
        return true;
      }
      else {
        return false;
      }
    }

  //Set step status if Mechanic flag is Y and inspector rejected.
  private checkRequestInspectionWithMechFlagInspFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'HOLD' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N'
      && params.STEP_ACTIVITY_STATUS !== null) {
      return true;
    }
    else {
      return false;
    }
  }



    //Set step status if Mechanic flag is Y and inspector rejected.
    private checkRequestInspectionWithMechFlagInspRejectFlag(params: workCardStepsModel): boolean {
      if (params.STATUS === 'HOLD' && params.STATUS_REASON === 'MAINT'
        && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
        && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
        && params.INSPECTOR_SIGNOFF_FLAG === 'N'
        && params.STEP_ACTIVITY_STATUS === null) {
        return true;
      }
      else {
        return false;
      }
    }

    //Set step status if Mechanic flag is Y and inspector rejected.
    private checkFinalBuybackCorrected(params: workCardStepsModel): boolean {
      if (params.STATUS === 'CLOSED' && params.STATUS_REASON === 'CORRECTED'
        && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
        && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
        && params.INSPECTOR_SIGNOFF_FLAG === 'N'
        && params.CURRENT_ACTIVITY_RESULT === 'CORRECTED'
        && params.STEP_NAME === 'FINAL BUYBACK') {
        return true;
      }
      else {
        return false;
      }
    }

  private checkRequestInspectionWithoutMechFlagInspFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'HOLD' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'N'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N'
      && params.STEP_ACTIVITY_STATUS !== null) {
      return true;
    }
    else {
      return false;
    }
  }


// Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
// 1. Check if initially rejected by inspector
private isInitialInspectionRejected(params: workCardStepsModel): boolean {
  return params.STATUS === 'HOLD' &&
         params.STATUS_REASON === 'MAINT' &&
         params.STAMPED_BY_INSPECTOR_FLAG === 'Y' &&
         params.INSPECTOR_STAMP_NUMBER !== null &&
         params.CURRENT_ACTIVITY_RESULT === 'REJECT' &&
         params.STEP_ACTIVITY_STATUS === null;
}

// Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
// 2. Check if corrected after rejection by inspector
private isCorrectionAfterInspectionReject(params: workCardStepsModel): boolean {
  return params.STATUS === 'HOLD' &&
         params.STATUS_REASON === 'MAINT' &&
         params.STAMPED_BY_INSPECTOR_FLAG === 'Y' &&
         params.INSPECTOR_STAMP_NUMBER !== null &&
         params.STEP_ACTIVITY_STATUS === 'EDITED' &&
         params.CURRENT_ACTIVITY_RESULT === 'REJECT';
}

// Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
// 3. Check if inspection was requested after CIR rejection
private isInspectionRequestedAfterReject(params: workCardStepsModel): boolean {
  return (params.STATUS === 'HOLD') &&
         params.STATUS_REASON === 'INSPECTOR' &&
         params.STAMPED_BY_INSPECTOR_FLAG === 'Y' &&
         params.STAMPED_BY_INSPECTOR_EMP_NO !== null
}

// 3. Check if inspection was requested after CIR rejection
private isInspectionRequestedAfterRejectInspInProcess(params: workCardStepsModel): boolean {
  return (params.STATUS === 'IN-WORK') &&
         params.STATUS_REASON === 'INSPECTOR' &&
         params.STAMPED_BY_INSPECTOR_FLAG === 'Y' &&
         params.STAMPED_BY_INSPECTOR_EMP_NO !== null
}

// Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
// 4. Check if inspection was canceled by technician after CIR rejection
private isInspectionCanceledByTechnician(params: workCardStepsModel): boolean {
  return params.STATUS === 'IN-WORK' &&
         params.STATUS_REASON === 'MAINT' &&
         params.INSPECTOR_STAMP_NUMBER !== null &&
         params.STAMPED_BY_INSPECTOR_FLAG === 'Y';
}

// Task 44245 : Edge Scenario Inspector Rejecting on Behalf of Customer
// 5. Check if inspection is in progress after CIR rejection
private isInspectionInProgressAfterReject(params: workCardStepsModel): boolean {
  return params.STATUS === 'IN-WORK' &&
         params.STATUS_REASON === 'INSPECTOR' &&
         params.INSPECTOR_STAMP_NUMBER !== null &&
         params.STAMPED_BY_INSPECTOR_FLAG === 'Y';
}

  //Set step status if awaiting inspection.
  private checkAwaitingInpection(params: workCardStepsModel): boolean {
    if (params.STATUS === 'HOLD' && params.STATUS_REASON === 'INSPECTOR'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
      && params.INSPECTOR_SIGNOFF_FLAG !== 'Y') {
      return true;
    }
    else {
      return false;
    }
  }


  //Set step status if awaiting inspection without Mechanic stamp
  private checkAwaitingInpectionWithoutMechFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'HOLD' && params.STATUS_REASON === 'INSPECTOR'
    && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
    && params.STAMPED_BY_MECHANIC_FLAG === 'N'
    && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
    return true;
  }
  else {
    return false;
  }
  }

  //Set step status if inspection is in progress.
  private checkInspectionInprogress(params: workCardStepsModel): boolean {
    if (params.STATUS === 'IN-WORK' && params.STATUS_REASON === 'INSPECTOR'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

   //Set step status if inspection is in progress without Mechanic stamp.
   private checkInspectionInprogressWithoutMechFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'IN-WORK' && params.STATUS_REASON === 'INSPECTOR'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'N'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

  //Set step status if Inspector and Mechanic flag is N.
  private checkStatusWithoutInsAndMechFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'HOLD' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.CURRENT_ACTIVITY_RESULT !== 'REJECT'
      && params.STAMPED_BY_MECHANIC_FLAG === 'N'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

  private checkRejectMaintStampNotExist(params: workCardStepsModel): boolean {
    if (params.STATUS === 'HOLD' && params.STATUS_REASON === 'MAINT'
      && params.CURRENT_ACTIVITY_RESULT === 'REJECT'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N'
      && params.STEP_ACTIVITY_STATUS === null
      && params.STAMPED_BY_MECHANIC_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

  //Set step status if Inspector and Mechanic flag is Y.
  private checkStatusWithInsAndMechFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'CLOSED' && params.STATUS_REASON === 'COMPLETED'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'Y'
      && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
      && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
      return true;
    }
    else {
      return false;
    }
  }

 //Set step status if Inspector and Mechanic flag is Y.
 private checkStatusWithInsDoneWithoutMechFlag(params: workCardStepsModel): boolean {
  if (params.STATUS === 'CLOSED' && params.STATUS_REASON === 'COMPLETED'
    && params.STAMPED_BY_INSPECTOR_FLAG === 'Y'
    && params.STAMPED_BY_MECHANIC_FLAG === 'N'
    && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
    return true;
  }
  else {
    return false;
  }
}

  //Set step status if Inspector signoff flag is N.
  private checkWithInspectorSignOffFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'IN-WORK' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'N'
      && params.INSPECTOR_SIGNOFF_FLAG === 'Y') {
      return true;
    }
    else {
      return false;
    }
  }

   //Set step status if Inspector and Mechanic flag is Y.For status Open and new
 private checkStatusWithInsDoneWithoutMechFlagOpenNew(params: workCardStepsModel): boolean {
  if (params.STATUS === 'OPEN' && params.STATUS_REASON === 'NEW'
    && params.STAMPED_BY_INSPECTOR_FLAG === 'Y'
    && params.STAMPED_BY_MECHANIC_FLAG === 'N'
    && params.INSPECTOR_SIGNOFF_FLAG === 'N') {
    return true;
  }
  else {
    return false;
  }
}

  //Set step status if Inspector signoff flag is N.For status Open and new
  private checkWithInspectorSignOffFlagOpenNew(params: workCardStepsModel): boolean {
    if (params.STATUS === 'OPEN' && params.STATUS_REASON === 'NEW'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'N'
      && params.INSPECTOR_SIGNOFF_FLAG === 'Y') {
      return true;
    }
    else {
      return false;
    }
  }

  //Set step status if Inspector signoff flag is Y.
  private checkWithoutInspectorSignOffFlag(params: workCardStepsModel): boolean {
    if (params.STATUS === 'IN-WORK' && params.STATUS_REASON === 'MAINT'
      && params.STAMPED_BY_INSPECTOR_FLAG === 'N'
      && params.STAMPED_BY_MECHANIC_FLAG === 'Y'
      && params.INSPECTOR_SIGNOFF_FLAG === 'Y') {
      return true;
    }
    else {
      return false;
    }
  }
  //Update step parameters.
  private updateWorkCardStepData(isEditable: boolean, technicianStatus: string, inspectorStatus: string, inspectorStatusEnabled: boolean): WorkCardStepsStatus {
    let stepStatus: WorkCardStepsStatus = new WorkCardStepsStatus();
    stepStatus.isEditable = isEditable;
    stepStatus.technicianStatus = technicianStatus;
    stepStatus.inspectorStatus = inspectorStatus;
    stepStatus.inspectorStatusEnabled = inspectorStatusEnabled;
    return stepStatus;
  }

  //map new MS work card step model to ui legacy

  public cirMapping(cir: any){
      const temp: RoutineCustomerStepsResModel = {
      ACTIVE: cir.active,
      APPROVAL_REASON: cir.approvalReason,
      APPROVAL_STATUS: cir.approvalStatus,
      CREATED_BY_REP_STAMP_NUMBER: cir.createdByRepStampNumber,
      CUSTOMER_CARD_STEPS_ID: cir.customerCardStepsId,
      CUSTOMER_ID: cir.customerId,
      CUSTOMER_NAME: cir.customerName,
      CUSTREP_NUMBER: cir.custrepNumber,
      CUSTREP_OPERATION_ON: cir.custrepOperationOn,
      CUST_REP_FIRST_NAME: cir.custRepFirstName,
      CUST_REP_LAST_NAME: cir.custRepLastName,
      DESCRIPTION: cir.description,
      DIV_NO: cir.divNo,
      DOCUMENT_ID: cir.documentId,
      DT_CREATED: cir.dtCreated,
      DT_MODIFIED: cir.dtModified,
      DT_CREATED_FORMATTED: cir.dtCreated,
      DT_MODIFIED_FORMATTED: cir.custStepsDtModifiedFrmted,
      OPERATION: cir.operation,
      PAGE_NUMBER: cir.pageNumber,
      PARENT: cir.parent,
      PARENT_STEP_ID: cir.parentStepId,
      PERFORMED_BY_CUST_REP_NUMBER: cir.performedByCustRepNumber,
      STRIKE_OFF_FLAG: cir.strikeOffFlag,
      VOIDED_BY_REP_STAMP_NUMBER: cir.voidedByRepStampNumber,
      WORK_CARD_ID: cir.workCardId,
      X_POSITION: cir.xposition,
      Y_POSITION: cir.yposition
    }
    return temp;
  }

  public workCardStepsMapping(res: any[], inspectionAction: string = 'none'){
    let workCardSteps : any[] = [];

    res.forEach( step => {
      if (step['customerCardStepsId'] === undefined){
        const temp: workCardStepsModel = {
          DIV_NO: step.divNo,
          PROJECT_NUMBER: step.projectNumber,
          WORK_ORDER_NUMBER: step.workOrderNumber,
          ZONE_NUMBER: step.zoneNumber,
          ITEM_NUMBER: step.itemNumber,
          CARD_DESCRIPTION: step.cardDescription,
          CUSTOMER_WORK_CARD: step.customerWorkCard,
          WORK_CARD_ID: step.workCardId,
          STEP_NUMBER: step.stepNumber,
          DISPLAY_STEP_NUMBER: step.displayStepNumber,
          STEP_NAME: step.stepName,
          CURRENT_ACTIVITY_RESULT: step.currentActivityResult,
          DESCRIPTION: step.description,
          DOCUMENT_TYPE: step.documentType,
          PAGE_NUMBER: step.pageNumber,
          DOCUMENT_ITEM_NUMBER: step.documentItemNumber,
          CORRECTIVE_ACTION: step.correctiveAction,
          STATUS: step.status,
          STRIKE_OUT_FLAG: step.strikeOutFlag,
          STATUS_REASON: step.statusReason,
          CURRENT_ACTIVITY_EMPLOYEE: step.currentActivityEmployee,
          CURRENT_ACTIVITY_EMP_NAME: step.currentActivityEmpName,
          CURRENT_ACTIVITY_COMMENT: step.currentActivityComment,
          CURRENT_ACTIVITY_DATE: step.currentActivityDate,
          CURRENT_ACTIVITY_CODE: step.currentActivityCode,
          CURRENT_EMPLOYEE_FTY: step.currentEmployeeFty,
          CURRENT_EMPLOYEE_COLOR_CODE: step.currentEmployeeColorCode,
          PREVIOUS_ACTIVITY_EMPLOYEE: step.previousActivityEmployee,
          PREVIOUS_ACTIVITY_COMMENT: step.previousActivityComment,
          PREVIOUS_ACTIVITY_DATE: step.previousActivityDate,
          PREVIOUS_ACTIVITY_RESULT: step.previousActivityResult,
          PREVIOUS_ACTIVITY_CODE: step.previousActivityCode,
          PREVIOUS_EMPLOYEE_COLOR_CODE: step.previousEmployeeColorCode,
          INSPECTOR_SIGNOFF_FLAG: step.inspectorSignoffFlag,
          RII_FLAG: step.riiFlag,
          SKILL_CODE_ID: step.skillCodeId,
          SKILL_CODE: step.skillCode,
          WORK_CENTER_ID: step.workCenterId,
          WORK_CENTER: step.workCenter,
          WORK_CENTER_OPERATION_ID: step.workCenterOperationId,
          OPERATION_CODE: step.operationCode,
          ESTIMATED_HOURS: step.estimatedHours,
          APPROVED_HOURS: step.approvedHours,
          COMPLETED_QUANTITY: step.completedQuantity,
          SCRAPPED_QUANTITY: step.scrappedQuantity,
          CREATED_BY_EMPLOYEE_ID: step.createdByEmployeeId,
          CREATED_BY_EMPLOYEE_NUMBER: step.createdByEmployeeNumber,
          CREATED_BY_EMPLOYEE_NAME: step.createdByEmployeeName,
          APPROVED_BY_EMPLOYEE_ID: step.approvedByEmployeeId,
          APPROVED_BY_EMPLOYEE_NUMBER: step.approvedByEmployeeNumber,
          APPROVED_BY_EMPLOYEE_NAME: step.approvedByEmployeeName,
          SOURCE_CARD_ID: step.sourceCardId,
          SOURCE_WORK_ORDER_NUMBER: step.sourceWorkOrderNumber,
          SOURCE_ZONE_NUMBER: step.sourceZoneNumber,
          SOURCE_ITEM_NUMBER: step.sourceItemNumber,
          TRANSFER_COUNT: step.transferCount,
          SOURCE_CARD_STEP_ID: step.sourceCardStepId,
          SOURCE_STEP_NUMBER: step.sourceStepNumber,
          SOURCE_STEP_NAME: step.sourceStepName,
          SOURCE_STEP_DESCRIPTION: step.sourceStepDescription,
          CARD_STEP_ID: step.cardStepId,
          MECHANIC_CUSTOMER_EMPL_NUMBER: step.mechanicCustomerEmplNumber,
          INSPECTOR_CUSTOMER_EMPL_NUMBER: step.inspectorCustomerEmplNumber,
          LIC_MECH_CUSTOMER_EMPL_NUMBER: step.licMechCustomerEmplNumber,
          ACTIVE: step.active,
          PROGRAM_ID: step.programId,
          DT_CREATED: step.dtCreated,
          USR_CREATED: step.usrCreated,
          DT_MODIFIED: step.dtModified,
          FORMATTED_DT_MODIFIED: step.dtModifiedFormatted,
          USR_MODIFIED: step.usrModified,
          TOKEN: step.token,
          REQUESTED_DATE: step.requestedDate,
          REQUESTED_BY: step.requestedBy,
          STAMPED_BY_INSPECTOR_FLAG: step.stampedByInspectorFlag,
          STAMPED_BY_MECHANIC_FLAG: step.stampedByMechanicFlag,
          STAMPED_BY_LIC_MECHANIC_FLAG: step.stampedByLicMechanicFlag,
          STAMPED_BY_LIC_MECH_EMP_ID: step.stampedByLicMechEmpId,
          STAMPED_BY_INSPECTOR_EMP_ID: step.stampedByInspectorEmpId,
          STAMPED_BY_LIC_MECHANIC_EMP_NO: step.stampedByLicMechanicEmpNo,
          STAMPED_BY_MECHANIC_DATE: step.stampedByMechanicDate,
          STAMPED_BY_LIC_MECHANIC_DATE: step.stampedByLicMechanicDate,
          STAMPED_BY_INSPECTOR_DATE: step.stampedByInspectorDate,
          MECHANIC_STAMP_NUMBER: step.mechanicStampNumber,
          LIC_MECHANIC_STAMP_NUMBER: step.licMechanicStampNumber,
          INSPECTOR_STAMP_NUMBER: step.inspectorStampNumber,
          STEP_ACTIVITY_STATUS: step.stepActivityStatus,
          LEAD_REJECT_FLAG: step.leadRejectFlag,
          STEP_INDEX: step.stepIndex,
          WORK_ORDER_TYPE: step.workOrderType,
          WORK_CARD_CORRECTIVE_ACTION: step.workCardCorrectiveAction,
          persona: step.persona,
          STAMPED_BY_MECHANIC_EMP_NAME: step.stampedByMechanicEmpName,
          PRIMARY_SKILL_CODE: step.primarySkillCode,
          ALL_SKILL_CODES: step.allSkillCodes,
          CREATED_BY_EMPLOYEE_FIRSTNAME: step.createdByEmployeeFirstname,
          CREATED_BY_EMPLOYEE_LASTNAME: step.createdByEmployeeLastname,
          CREATED_BY_EMPLOYEE_TAG: step.createdByEmployeeTag,
          CREATED_DATE_FORMATTED: step.createdDateFormatted,
          APPROVED_BY_EMPLOYEE_FIRSTNAME: step.approvedByEmployeeFirstname,
          APPROVED_BY_EMPLOYEE_LASTNAME: step.approvedByEmployeeLastname,
          REQUESTED_BY_FULL_NAME: step.requestedByFullName,
          INSPECTED_BY_FULL: step.inspectedByFull,
          INSPECTED_BY: step.inspectedBy,
          INSPECTED_DATE: step.inspectedDate,
          PROCESSED_BY_EMPLOYEE_ID: step.processedByEmployeeId,
          PROCESSED_BY_EMPLOYEE_NUMBER: step.processedByEmployeeName,
          PROCESSED_BY_EMPLOYEE_NAME: step.processedByEmployeeName,
          STAMPED_BY_MECHANIC_EMP_NO: step.stampedByMechanicEmpNo,
          STAMPED_BY_MECHANIC_EMP_ID: step.stampedByMechanicEmpId,
          MECHANIC_STAMP_CATEGORY: step.mechanicStampCategory,
          MECHANIC_STAMP_TYPE: step.mechanicStampType,
          STAMPED_BY_INSPECTOR_EMP_NO: step.stampedByInspectorEmpNo,
          STAMPED_BY_INSPECTOR_EMP_NAME: step.stampedByInspectorEmpName,
          INSPECTOR_STAMP_CATEGORY: step.inspectorStampCategory,
          INSPECTOR_STAMP_TYPE: step.inspectorStampType,
          STAMPED_BY_REP_FLAG: step.stampedByRepFlag,
          STAMPED_BY_REP_DATE: step.stampedByRepDate,
          STAMPED_BY_REP_NUMBER: step.stampedByRepNumber,
          STAMPED_BY_REP_ID: step.stampedByRepId,
          STAMPED_BY_REP_NAME: step.stampedByRepName,
          HANGAR: step.hangar,
          BAY: step.bay,
          LATEST_STEP_DESCRIPTION: step.latestStepDescription,
          LATEST_STEP_MODIFIED_DATE: step.latestStepModifiedDate,
          LATEST_STEP_MODIFIED_FDATE: step.latestStepModifiedFdate,
          LATEST_STEP_MODIFIED_EMP_ID: step.latestStepModifiedEmpId,
          LATEST_STEP_MODIFIED_EMP_FNAME: step.latestStepModifiedEmpFname,
          LATEST_STEP_MODIFIED_EMP_LNAME: step.latestStepModifiedEmpLname,
          LATEST_STEP_MODIFIED_EMP_NBR: step.latestStepModifiedEmpNbr,
          CUST_REP_APPROVAL_FLAG: step.custRepApprovalFlag,
          GROUP_ID: step.groupId,
          EIE_INDEX: step.eieIndex,
          REQUEST_TYPE: step.requestType,
          SOURCE_STEP_ID: step.sourceStepId,
          SOURCE_STEP_ID_NAME: step.sourceStepIdName,
          SORT_ORDER: step.sortOrder,
          STEP_REJECT_COUNT: step.stepRejectCount,
          LEAD_SIGNOFF_FLAG: step.leadSignoffFlag,
          TERMINAL_ID: step.terminalid,
          PREVIOUS_ACTIVITY_EMP_NAME: step.previousActivityEmpName,
          PREVIOUS_EMPLOYEE_FTY: step.previousEmployeeFty,
          INSPECTED_BY_EMPLOYEE_NUMBER: step.inspectedByEmployeeNumber,
          REQUESTED_BY_EMPLOYEE_NUMBER: step.requestedByEmployeeNumber,
          CIR_EIE_STEP_INSP_ACCEPT_FLAG: step.cirEieStepInspAcceptFlag,
          FINAL_BUYBACK_LEAD_REJECT_FLAG: step.finalBuybackLeadRejectFlag
        }
        if (step['customerSteps'] && step['customerSteps'].length > 0){
          let customerSteps: any[] = [];
          step['customerSteps'].forEach ( cir => {
            customerSteps.push(this.cirMapping(cir));
          })
          temp['CUSTOMER_STEPS'] = customerSteps;
        }

        if (step['eieSteps'] && step['eieSteps'].length > 0){
          temp['EIE_STEPS'] = this.workCardStepsMapping(step['eieSteps']);
        }
        workCardSteps.push(temp);

      }else{
        switch(inspectionAction){
          case 'reject': {
            if (step['parentStepId'] !== null){
              workCardSteps.push(this.cirMapping(step))
            }
            break;
          }
          case 'none': {
            if (step['parentStepId'] === null){
              workCardSteps.push(this.cirMapping(step))
            }
            break;
          }
          case 'accept': {
             workCardSteps.push(this.cirMapping(step))
             break;
          }
        }
      }
    });
    return workCardSteps;
  }

  /** convert number to hours and minutes */
  convertNumToTime(number) {
    let time = '';
    if (number) {
      let sign: number | string = (number >= 0) ? 1 : -1;
      number = number * sign;
      let hour = Math.floor(number);
      let decpart = number - hour;
      let min = 1 / 60;
      decpart = min * Math.round(decpart / min);
      let minute = Math.floor(decpart * 60) + '';
      if (minute && minute.length < 2) {
        minute = '0' + minute;
      }
      sign = sign === 1 ? '' : '-';
      time = sign + hour + ':' + minute;
    }
    return time;
  }

  //Get initials from first Name and Last Name
  getShortNameCharacters(fName: string, lName: string): string {
    fName = (fName !== null && fName !== undefined && fName !== '') ? fName : '';
    lName = (lName !== null && lName !== undefined && lName !== '') ? lName : '';
    let str = fName + ' ' + lName;
    if (str.trim() !== '') {
      let splitStr = str.split(' ');
      let first = splitStr[0].charAt(0);
      let last = splitStr.length > 1 ? (splitStr[splitStr.length - 1]).charAt(0) : '';
      return `${first}${last}`;
    } else {
      return '';
    }
  }

   //Get initials from first Name and and full for Last Name
   getFirstNameShortWithFullLastName(fName: string, lName: string): string {
    fName = (fName !== null && fName !== undefined && fName !== '') ? fName : '';
    lName = (lName !== null && lName !== undefined && lName !== '') ? lName : '';
    let str = fName + ' ' + lName;
    if (str.trim() !== '') {
      let splitStr = str.split(' ');
      let first = splitStr[0].charAt(0);
      return `${first}. ${lName}`;
    } else {
      return '';
    }
  }

  /*START: Methods to convert plain json into groupby field JSON objects*/
  groupBySingleField(data: any, field: string) {
    return data.reduce((acc, val) => {
      const rest = Object.keys(val).reduce((newObj, key) => {
        if (key !== field) {
          newObj[key] = val[key];
        }
        return newObj;
      }, {});
      if (acc[val[field]]) {
        acc[val[field]].push(rest);
      } else {
        acc[val[field]] = [rest];
      }
      return acc;
    }, {})
  }
  /*END: Methods to convert plain json into groupby field JSON objects*/

  // color code for turn over report 'Type' Chip control.
  turnOverTypeColorCode(typneName: string): IonicColor {
    let color:IonicColor;
    switch (typneName?.toLowerCase()) {
      case 'info': {
        color = IonicColor.success;
        break;
      }
      case 'concern': {
        color =  IonicColor.warning;
        break;
      }
      case 'critical': {
        color =  IonicColor.danger;
        break;
      }
      default: {
        color =  IonicColor.dark;
        break;
      }
    }
    return color;
  }

  getVerifierTypeFromRole(role: string): string {
    // !!!!!! WARNING !!!!!!
    // Changes to these mappings have important repercussions in the database.
    // Consult with the DB team before making changes here.
    const mapping = {
      'MRO - TECHNICIAN': 'TECH',
      'MRO - INSPECTOR': 'INSPECTOR',
      'MRO - LEAD': 'TECH',
      'MRO - SUPERVISOR': 'TECH',
      'MRO - CUSTOMER': 'CUST_REP',
    }

    return mapping[role] || 'TECH';
  }

  getDate(): string {
    let now = new Date();
    return now.getDate() + '/' + (now.getMonth() + 1) + '/' + now.getFullYear();
  }
}
